import { formatearMoneda } from "@uirtus/shared";

/**
 * El desglose de totales, usado tanto en el editor (calculado en vivo)
 * como en la ficha de detalle (valores ya persistidos). Una sola definición
 * evita que los dos lugares presenten el desglose de forma distinta.
 */
export function ResumenTotales({
  subtotal,
  descuento,
  iva,
  retenciones,
  total,
  moneda,
}: {
  subtotal: string;
  descuento: string;
  iva: string;
  retenciones: string;
  total: string;
  moneda: string;
}) {
  return (
    <dl className="ml-auto w-full max-w-64 space-y-1 text-sm">
      <Fila etiqueta="Subtotal" valor={formatearMoneda(subtotal, moneda)} />
      {Number(descuento) > 0 && (
        <Fila etiqueta="Descuento" valor={`-${formatearMoneda(descuento, moneda)}`} negativo />
      )}
      <Fila etiqueta="IVA" valor={formatearMoneda(iva, moneda)} />
      {Number(retenciones) > 0 && (
        <Fila
          etiqueta="Retenciones"
          valor={`-${formatearMoneda(retenciones, moneda)}`}
          negativo
        />
      )}
      <div className="flex justify-between border-t border-slate-200 pt-1.5 font-semibold dark:border-slate-800">
        <dt>Total</dt>
        <dd className="font-mono">{formatearMoneda(total, moneda)}</dd>
      </div>
    </dl>
  );
}

function Fila({
  etiqueta,
  valor,
  negativo,
}: {
  etiqueta: string;
  valor: string;
  negativo?: boolean;
}) {
  return (
    <div className="flex justify-between">
      <dt className="text-slate-500">{etiqueta}</dt>
      <dd className={`font-mono ${negativo ? "text-red-600 dark:text-red-400" : ""}`}>
        {valor}
      </dd>
    </div>
  );
}
